import { render, staticRenderFns } from "./ParkingService.vue?vue&type=template&id=23af8a34&scoped=true"
import script from "./ParkingService.vue?vue&type=script&lang=js"
export * from "./ParkingService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af8a34",
  null
  
)

export default component.exports